import { initElements } from '../../lib/utils';
export function initLanguageSwitcher() {
    initElements('.languageSwitcher', (el) => {
        const btnEl = el.querySelector('.languageSwitcher-button');
        const contentEl = el.querySelector('.languageSwitcher-content');
        btnEl.addEventListener('click', e => {
            e.preventDefault();
            contentEl.classList.toggle('is--active');
        });
    });
}
